import { z } from 'zod/v4';

export const CIDTO = z.object({
  id: z.uuid(),
  ci_name: z.string(),
  ci_type_name: z.string(),
});
export type CI = z.infer<typeof CIDTO>;